import { createAction, props } from '@ngrx/store';
import { WebSocketMessage } from './web-socket-message.model';


export const webSocketMessage = createAction('[WebSocket] Message', props<{ message: WebSocketMessage }>());
